import React from 'react';
import classNames from 'classnames';

import { LabeledCheckboxRadioInput } from '../checkbox-radio-input/labeled-checkbox-radio-input.component';

export type CheckboxGroupProps = {
  items: {
    value: string;
    label: string;
    helpText?: string;
    disabled?: boolean;
  }[];
  value: string[];
  className?: string;
  showAllCheckbox?: boolean;
  hasError?: boolean;
  disabled?: boolean;
  onChange: (value: string[]) => void;
};

export const CheckboxGroup = ({
  value,
  className,
  items,
  showAllCheckbox = false,
  onChange,
  hasError,
  disabled,
}: CheckboxGroupProps) => {
  const areNonSelected = value.length === 0;
  const areAllSelected = items.every((item) => value.includes(item.value));

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const itemValue = event.target.value;

    if (value.includes(itemValue)) {
      onChange(value.filter((v) => v !== itemValue));
    } else {
      onChange([...value, itemValue]);
    }
  };

  const handleSelectAll = () => {
    if (areAllSelected) {
      onChange([]);
    } else {
      onChange(items.map((item) => item.value));
    }
  };

  return (
    <div className={classNames('space-y-3', className)}>
      {showAllCheckbox && (
        <LabeledCheckboxRadioInput
          type="checkbox"
          label="All"
          checked={areAllSelected}
          disabled={disabled}
          indeterminate={!(areAllSelected || areNonSelected)}
          onChange={handleSelectAll}
        />
      )}
      {items.map(
        ({
          value: itemValue,
          label: itemLabel,
          helpText: itemHelpText,
          disabled: itemDisabled,
        }) => (
          <LabeledCheckboxRadioInput
            type="checkbox"
            key={itemValue}
            value={itemValue}
            checked={value.includes(itemValue)}
            disabled={disabled || itemDisabled}
            label={itemLabel}
            helpText={itemHelpText}
            onChange={handleChange}
            hasError={hasError}
          />
        )
      )}
    </div>
  );
};
